import { render, staticRenderFns } from "./CtintMainTabSingle.vue?vue&type=template&id=3643ec7f&"
import script from "./CtintMainTabSingle.vue?vue&type=script&lang=js&"
export * from "./CtintMainTabSingle.vue?vue&type=script&lang=js&"
import style0 from "./CtintMainTabSingle.vue?vue&type=style&index=0&id=3643ec7f&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports